import React from 'react';

import { Row, Col } from 'react-bootstrap';

import { CheckboxField, ControlPageBlock, InputField } from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';
import { Text2Slug } from '../tools/converters';

export default class ChannelsEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            slug: '',
            priority: 'up',
            is_visible: 0,
        };
        this.handleChange = this.handleChange.bind(this);
        this.titleChange = this.titleChange.bind(this);
        this.handleData = this.handleData.bind(this);
        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);
        this.goToNewPage = this.goToNewPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);

        if (props.match.params.id) {
            this.API_ENDPOINT = `channels/${props.match.params.id}/`;
        } else {
            this.setState({});
            this.API_ENDPOINT = 'channels/';
        }
    }

    handleData(data) {
        this.setState(data);
    }

    sendData(event) {
        const save_type = event.currentTarget.id;
        let request_method = 'PUT';

        if (!this.props.match.params.id) {
            request_method = 'POST';
        }

        // TODO: sorry about that, but its all about DB structure
        if (!this.state.is_visible) {
            this.setState({ is_visible: 0 });
        }
        //

        let callback = this.handleData;

        if (save_type === 'save_button') {
            callback = this.goToPreviousPage;
        }

        if (!this.props.match.params.id) {
            callback = this.goToNewPage;
        }

        Fetcher(this.API_ENDPOINT, request_method, callback, this.state);
    }

    goToNewPage(newData) {
        this.API_ENDPOINT = `channels/${newData.id}/`;
        this.props.history.push(`${PROJECT_PREFIX}/channels/${newData.id}/edit`);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/channels/all`);
    }

    removeData() {
        Fetcher(this.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    handleChange(event) {
        let state = event.currentTarget.value;

        if (event.currentTarget.type === 'checkbox') {
            if (event.currentTarget.checked) {
                state = 1;
            } else {
                state = 0;
            }
        }

        this.setState({ [[event.currentTarget.id]]: state });
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            Fetcher(this.API_ENDPOINT, 'GET', this.handleData);
        } else {
            this.setState({
                name: '',
                slug: '',
                priority: 'up',
                is_visible: 0,
            });
        }
    }

    titleChange(event) {
        const state = event.currentTarget.value;
        this.setState({ [[event.currentTarget.id]]: state, slug: Text2Slug(state) });
    }

    render() {
        return (
            <div>
                <div className="container">
                    <Row className="show-grid">
                        <Col md={12}>
                            <h3>
                                Канал:
                                {this.state.name}
                            </h3>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={8}>
                            <InputField
                                name="name"
                                label="Название"
                                value={this.state.name}
                                onChange={this.titleChange}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={8}>
                            <InputField
                                name="slug"
                                label="Slug"
                                value={this.state.slug}
                                onChange={this.handleChange}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col md={6}>
                            <CheckboxField
                                name="is_visible"
                                label="Видимые"
                                value={this.state.is_visible}
                                onChange={this.handleChange}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="container-fluid">
                    <ControlPageBlock
                        name={this.state.name}
                        onSave={this.sendData}
                        onApply={this.sendData}
                        onCancel={this.goToPreviousPage}
                        onRemove={this.removeData}
                    />
                </div>
            </div>
        );
    }
}
